/**
 * Bug-report link helper — issue #969.
 *
 * Reads VITE_BUG_REPORT_REPO / VITE_BUG_REPORT_DISABLED from the build
 * environment so forks and white-label / OEM deployments can point at
 * their own tracker or hide the link entirely without a code change.
 *
 * No client-side context capture — the link is a plain URL with no
 * pre-fill, no `window.location.href`, no project id, no version
 * string. The GitHub issue form scaffolds what we need from the user.
 */

const DEFAULT_REPO = 'mudit70/veodiagram';

export function getBugReportConfig(): {
  enabled: boolean;
  href: string;
} {
  const repo = (import.meta.env.VITE_BUG_REPORT_REPO as string | undefined) ?? DEFAULT_REPO;
  const disabled =
    (import.meta.env.VITE_BUG_REPORT_DISABLED as string | undefined) === 'true';
  return {
    enabled: !disabled,
    // /choose so the user picks bug vs feature; falls through to the
    // generic new-issue page on repos that don't have templates.
    href: `https://github.com/${repo}/issues/new/choose`,
  };
}
